export default __webpack_public_path__ + "b7956f06bcfeff793a89ac72479dcaa0.jpeg";